import React from "react";
import { Check } from "lucide-react";

const SkuSelection = ({ questionnaireData, handleSkuChange }) => {
  const skuOptions = ["HCM", "Finance", "Payroll", "Benefits"];

  return (
    <div className="space-y-6">
      <h3 className="text-xl font-medium text-gray-900">SKU Selection</h3>
      <p className="text-gray-600">
        Select the Workday modules you want to implement as part of your
        migration.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {skuOptions.map((sku) => (
          <div
            key={sku}
            className={`p-4 border rounded-lg cursor-pointer transition-all ${
              questionnaireData.skuSelection.includes(sku)
                ? "border-blue-500 bg-blue-50 shadow-sm"
                : "border-gray-200 hover:border-blue-300 hover:bg-blue-50"
            }`}
            onClick={() => handleSkuChange(sku)}
          >
            <div className="flex items-center">
              <span className="text-gray-700">Workday {sku}</span>
              {questionnaireData.skuSelection.includes(sku) && (
                <Check className="ml-auto text-blue-500" size={18} />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkuSelection;
